import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'downloading': false,
  'list': [],
};

export const partsSales = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PARTS_SALES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PARTS_SALES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_PARTS_SALES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.DOWNLOADING_PARTS_SALES_LIST]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_PARTS_SALES_LIST]: (state, action) => {
      downloadFile(action.response.data);
      
      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_PARTS_SALES_LIST_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
